import { render, staticRenderFns } from "./allcustomerSingle.vue?vue&type=template&id=a19f25c2&scoped=true&"
import script from "./allcustomerSingle.vue?vue&type=script&lang=js&"
export * from "./allcustomerSingle.vue?vue&type=script&lang=js&"
import style0 from "./allcustomerSingle.vue?vue&type=style&index=0&id=a19f25c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a19f25c2",
  null
  
)

export default component.exports